export default __webpack_public_path__ + "static/media/ic-graph-column.dfaea053.svg";